module.exports = "pegasus/assets/square-twitter.gif";